import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { policyService } from '../api';
import type { PolicyViewModel } from '../api/types/policy';
import { policyRoutePath } from '../utils/policyRouteSlug';

const Footer: React.FC = () => {
  const [policies, setPolicies] = useState<PolicyViewModel[]>([]);
  const etbisLogoUrl = process.env.REACT_APP_ETBIS_LOGO_URL?.trim();
  const guvenDamgasiLogoUrl = process.env.REACT_APP_GUVEN_DAMGA_LOGO_URL?.trim();
  const etbisLinkUrl = process.env.REACT_APP_ETBIS_LINK_URL?.trim();
  const guvenDamgasiLinkUrl = process.env.REACT_APP_GUVEN_DAMGA_LINK_URL?.trim();
  const hasTrustBadges = Boolean(etbisLogoUrl || guvenDamgasiLogoUrl);

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const result = await policyService.getActivePolicies();
        const list = result.data;
        setPolicies(Array.isArray(list) ? list : []);
      } catch (error) {
        console.error('Error fetching policies:', error);
        // Silently fail - footer will show without dynamic policies
      }
    };

    fetchPolicies();
  }, []);

  return (
    <footer
      className="footer mt-auto py-5 border-top"
      style={{
        position: 'sticky',
        top: '100%',
        left: 0,
        width: '100%',
        zIndex: 1,
        backgroundColor: 'var(--sb-bg)',
      }}
    >
      <div className="container">
        <div className="row g-4">
          <div className="col-12 col-md-6 col-lg-3 text-center text-md-start">
            <h5 className="mb-3">Hakkımızda</h5>
            <p className="text-secondary">
              SadeceBilgisayar.com, sıfır veya İkinci el teknolojik ürünleri güvenilir bir şekilde alım veya satım yapabileceğiniz bir platformdur.
            </p>
          </div>
          <div className="col-12 col-md-6 col-lg-3 text-center text-md-start">
            <h5 className="mb-3">Önemli Tavsiyeler</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link className="text-secondary text-decoration-none d-inline text-nowrap" to="/masaustu_tavsiyeler">
                  Masaüstü alırken dikkat edilmesi gerekenler
                </Link>
              </li>
              <li className="mb-2">
                <Link className="text-secondary text-decoration-none d-inline" to="/laptop-tavsiyeler">
                  Laptop alırken dikkat edilmesi gerekenler
                </Link>
              </li>
              <li className="mb-2">
                <Link className="text-secondary text-decoration-none d-inline" to="/donanim-tavsiyeler">
                  Donanım alırken dikkat edilmesi gerekenler
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-12 col-md-6 col-lg-4 text-center text-md-start">
            <h5 className="mb-3">Sosyal Medya Hesaplarımız</h5>
            <div className="social-links">
              <a className="text-primary me-4" href="#">
                <i className="fab fa-facebook fa-3x"></i>
              </a>
              <a className="text-danger me-4" href="#">
                <i className="fab fa-instagram fa-3x"></i>
              </a>
              <a className="text-danger" href="#">
                <i className="fab fa-youtube fa-3x"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom mt-5 pt-4 border-top">
          {hasTrustBadges ? (
            <div className="row align-items-center g-3 mb-4">
              <div className="col-12 text-center">
                <div className="d-flex flex-wrap justify-content-center align-items-center gap-4">
                  {etbisLogoUrl ? (
                    etbisLinkUrl ? (
                      <a href={etbisLinkUrl} target="_blank" rel="noopener noreferrer">
                        <img src={etbisLogoUrl} alt="ETBIS" height={48} />
                      </a>
                    ) : (
                      <img src={etbisLogoUrl} alt="ETBIS" height={48} />
                    )
                  ) : null}
                  {guvenDamgasiLogoUrl ? (
                    guvenDamgasiLinkUrl ? (
                      <a href={guvenDamgasiLinkUrl} target="_blank" rel="noopener noreferrer">
                        <img src={guvenDamgasiLogoUrl} alt="Güven Damgası" height={48} />
                      </a>
                    ) : (
                      <img src={guvenDamgasiLogoUrl} alt="Güven Damgası" height={48} />
                    )
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
          <div className="row align-items-center g-2">
            <div className="col-12 col-md-6 text-center text-md-start">
              <p className="text-secondary mb-0 small">© {new Date().getFullYear()} SadeceBilgisayar.com - Tüm hakları saklıdır.</p>
            </div>
            <div className="col-12 col-md-6 text-center text-md-end">
              {policies.length > 0 ? (
                policies.map((policy) => (
                  <Link
                    key={policy.id}
                    className="text-secondary me-3"
                    to={policyRoutePath(policy.slug, policy.name)}
                  >
                    {policy.name}
                  </Link>
                ))
              ) : (
                <>
                  <Link className="text-secondary me-3" to="/gizlilik-politikasi">Gizlilik Politikası</Link>
                  <Link className="text-secondary me-3" to="/kullanici-sozlesmesi">Kullanım Koşulları</Link>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 